<template>
	<div class="container domain-page">
		<section class="page-hero">
			<div>
				<span class="eyebrow">DOMAIN POOL</span>
				<h2>域名管理</h2>
				<p>分别维护外部入口域名和参与轮询的中间域名。</p>
			</div>
			<el-button type="primary" icon="el-icon-plus" @click="open()">新增{{ isBackend ? '中间' : '入口' }}域名</el-button>
		</section>
		<el-card shadow="never" class="domain-card"
			><el-tabs v-model="activeType" class="domain-tabs" @tab-click="changeType"><el-tab-pane label="入口域名" name="1"/><el-tab-pane label="中间域名" name="2"/></el-tabs>
			<div class="role-tip"><i :class="isBackend ? 'el-icon-refresh' : 'el-icon-position'" />{{ isBackend ? '中间域名解析到本服务，按所属分组参与轮询。' : '入口域名可以部署在外部服务，只用于识别代理保留的原始 Host 和所属分组。' }}</div>
			<div class="toolbar">
				<el-select v-model="query.domain_group_id" clearable filterable placeholder="全部分组" @change="load"><el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id"/></el-select><el-input v-model.trim="query.content" clearable prefix-icon="el-icon-search" placeholder="搜索域名" @keyup.enter.native="load" /><el-button icon="el-icon-search" @click="load">搜索</el-button>
			</div>
			<div class="table-caption">
				<span>{{ isBackend ? '中间域名列表' : '入口域名列表' }}</span
				><small>共 {{ total }} 个域名</small>
			</div>
			<el-table class="domain-table" v-loading="loading" :data="list" empty-text="暂无域名">
				<el-table-column label="域名" prop="content" min-width="280"
					><template slot-scope="{ row }"
						><span class="domain-name"
							><i class="el-icon-link domain-icon" /><span>{{ row.content }}</span></span
						></template
					></el-table-column
				><el-table-column label="备注" prop="remark" min-width="180" show-overflow-tooltip />
				<el-table-column label="归属分组" min-width="190"
					><template slot-scope="{ row }"
						><el-tag class="group-tag" effect="plain" :class="{ 'is-unassigned': !row.domain_group_id }" :style="groupTagStyle(row.domain_group_id)"><i class="el-icon-collection-tag" />{{ groupName(row.domain_group_id) }}</el-tag></template
					></el-table-column
				><el-table-column v-if="!isBackend" label="接入方式" width="150" align="center"
					><template><el-tag size="mini" type="warning" effect="plain">外部代理</el-tag></template></el-table-column
				><el-table-column v-if="isBackend" label="24h 轮询次数" width="145" align="center"
					><template slot-scope="{ row }"
						><span>{{ row.round_robin_count || 0 }}</span></template
					></el-table-column
				>
				<el-table-column v-if="isBackend" label="直接访问" width="125" align="center"
					><template slot-scope="{ row }"
						><el-tag size="mini" effect="plain" :type="row.direct_block === 0 ? 'success' : 'info'">{{ row.direct_block === 0 ? '允许' : '拦截' }}</el-tag></template
					></el-table-column
				><el-table-column label="状态" width="155" align="center"
					><template slot-scope="{ row }"
						><el-switch v-model="row.state" :active-value="2" :inactive-value="1" @change="updateStatus(row, $event)" /><el-tag size="mini" :type="row.state === 2 ? 'success' : 'info'">{{ row.state === 2 ? '启用' : '停用' }}</el-tag></template
					></el-table-column
				><el-table-column label="操作" width="140" align="center"
					><template slot-scope="{ row }"><el-button type="text" @click="open(row)">编辑</el-button><el-button type="text" class="danger-button" @click="remove(row)">删除</el-button></template></el-table-column
				></el-table
			>
			<pagination v-if="total" :total="total" :page.sync="query.page" :limit.sync="query.pagesize" @pagination="load"
		/></el-card>
		<el-dialog :title="`${form.id ? '编辑' : '新增'}${isBackend ? '中间' : '入口'}域名`" :visible.sync="visible" width="560px" custom-class="domain-dialog"
			><div class="dialog-tip"><i class="el-icon-connection" /> {{ isBackend ? '中间域名只需填写主机名，保存后会同步到本机宝塔。' : '入口域名不会同步宝塔；外部代理需要保留原始 Host 和访客 IP。' }}</div>
			<el-form ref="form" :model="form" :rules="rules" label-width="90px"
				><el-form-item label="域名" prop="content"><el-input v-model.trim="form.content" placeholder="例如：a.example.com，无需 http(s)://"/></el-form-item> <el-form-item label="备注"><el-input v-model.trim="form.remark" maxlength="255" show-word-limit placeholder="请输入备注"/></el-form-item
				><el-form-item label="归属分组" prop="domain_group_id"
					><el-select v-model="form.domain_group_id" filterable placeholder="请选择分组" style="width:100%"><el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id"/></el-select></el-form-item
				><el-form-item v-if="isBackend" label="直接访问"
					><el-switch v-model="form.direct_block" :active-value="0" :inactive-value="1" active-text="允许" inactive-text="拦截" />
					<p class="field-help">使用外部入口域名时请拦截直接访问，要求携带入口 token。</p></el-form-item
				></el-form
			>
			<div slot="footer"><el-button @click="visible = false">取消</el-button><el-button type="primary" @click="save()">保存域名</el-button></div></el-dialog
		>
	</div>
</template>
<script>
	import { groupTagStyle } from '@/utils/group-tag';

	export default {
		name: 'CommonDomainManager',
		data() {
			return { loading: false, list: [], total: 0, groups: [], visible: false, activatedOnce: false, activeType: '2', query: { page: 1, pagesize: 20, domain_group_id: '', content: '', domain_type: 2 }, form: {}, rules: { content: [{ required: true, message: '请输入域名', trigger: 'blur' }], domain_group_id: [{ required: true, message: '请选择分组', trigger: 'change' }] } };
		},
		computed: {
			isBackend() {
				return this.activeType === '2';
			}
		},
		created() {
			this.loadGroups();
			this.load();
		},
		activated() {
			if (this.activatedOnce) this.loadGroups();
			this.activatedOnce = true;
		},
		methods: {
			groupTagStyle,
			loadGroups() {
				return this.request.get('/domain-group', { params: { state: 2 } }).then((data) => {
					this.groups = data.list || [];
				});
			},
			load() {
				this.loading = true;
				this.request
					.get('/domain', { params: this.query })
					.then((data) => {
						this.list = data.list || [];
						this.total = data.count || 0;
					})
					.finally(() => {
						this.loading = false;
					});
			},
			groupName(id) {
				const group = this.groups.find((item) => item.id === id);
				return group ? group.name : '未分组';
			},
			changeType() {
				this.query.domain_type = Number(this.activeType);
				this.query.page = 1;
				this.load();
			},
			async open(row) {
				await this.loadGroups();
				this.form = Object.assign({ content: '', remark: '', state: 2, domain_group_id: '', domain_type: Number(this.activeType), direct_block: 0 }, row || {});
				this.visible = true;
				this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
			},
			updateStatus(row, state) {
				this.request
					.post('/domain-edit', { id: row.id, state })
					.then(() => {
						this.$message.success('状态已更新');
					})
					.catch(() => {
						row.state = state === 2 ? 1 : 2;
					});
			},
			save() {
				this.$refs.form.validate((valid) => {
					if (!valid) return;
					const payload = { content: this.form.content, remark: this.form.remark || '', domain_group_id: this.form.domain_group_id, domain_type: this.form.domain_type, state: this.form.state, is_ios: this.form.is_ios, direct_block: this.isBackend ? this.form.direct_block : 0 };
					if (this.form.id) payload.id = this.form.id;
					const path = this.form.id ? '/domain-edit' : '/domain-add';
					this.request.post(path, payload).then((data) => {
						this.visible = false;
						this.load();
						if (data.bt_sync_failed) this.$message.warning(`域名已保存，但同步宝塔失败：${data.bt_sync_error}`);
						else this.$message.success('域名已保存');
					});
				});
			},
			remove(row) {
				this.$baseConfirm('确定删除该域名？', '提示', () =>
					this.request.post('/domain-remove', row).then(() => {
						this.$message.success('删除成功');
						this.load();
					})
				);
			}
		}
	};
</script>
<style scoped>
	.domain-page {
		padding-top: 18px;
	}
	.page-hero {
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		height: 96px;
		margin-bottom: 18px;
		padding: 14px 24px;
		color: #fff;
		border-radius: 14px;
		background: linear-gradient(120deg, #224b69, #438a9b);
		box-shadow: 0 10px 24px rgba(32, 76, 105, 0.15);
	}
	.eyebrow {
		color: rgba(255, 255, 255, 0.67);
		letter-spacing: 1.4px;
		font-size: 10px;
	}
	.page-hero h2 {
		margin: 2px 0 4px;
		font-size: 20px;
	}
	.page-hero p {
		margin: 0;
		color: rgba(255, 255, 255, 0.82);
		font-size: 12px;
	}
	.domain-card {
		border: 0;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(30, 54, 80, 0.08);
	}
	.domain-tabs {
		margin: -4px 0 12px;
	}
	.table-caption {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		padding: 2px 2px 14px;
		color: #30465f;
		font-size: 15px;
		font-weight: 600;
	}
	.table-caption small {
		color: #93a0ae;
		font-size: 12px;
		font-weight: 400;
	}
	.domain-table {
		overflow: hidden;
		border: 1px solid #e8eff5;
		border-radius: 10px;
	}
	.domain-table::v-deep th.el-table__cell {
		padding: 12px 0;
		color: #607287;
		background: #f7f9fc;
	}
	.domain-table::v-deep td.el-table__cell {
		padding: 15px 0;
	}
	.domain-table::v-deep td:first-child .cell,
	.domain-table::v-deep th:first-child .cell {
		text-align: left;
	}
	.role-tip {
		margin-bottom: 14px;
		padding: 10px 12px;
		color: #63798c;
		border-radius: 8px;
		background: #f4f8fb;
		font-size: 12px;
	}
	.role-tip i {
		margin-right: 7px;
		color: #4383a4;
	}
	.toolbar {
		display: flex;
		gap: 10px;
		margin-bottom: 16px;
	}
	.toolbar .el-select,
	.toolbar .el-input {
		width: 220px;
	}
	.domain-name {
		display: flex;
		align-items: center;
		max-width: 100%;
		overflow: hidden;
		color: #294b63;
		font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
		font-size: 13px;
		font-weight: 650;
		letter-spacing: 0.1px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.domain-name span {
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.domain-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 24px;
		height: 24px;
		margin-right: 9px;
		color: #4383a4;
		border-radius: 7px;
		background: #eaf5fa;
		font-size: 13px;
	}
	.el-tag {
		margin-left: 7px;
	}
	.group-tag {
		display: inline-flex;
		align-items: center;
		max-width: 138px;
		height: 26px;
		padding: 0 10px;
		overflow: hidden;
		color: #39718e;
		border-color: #c9deea;
		border-radius: 13px;
		background: #f2f8fc;
		font-weight: 600;
		line-height: 24px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.group-tag i {
		margin-right: 5px;
		color: inherit;
		font-size: 13px;
	}
	.group-tag.is-unassigned {
		color: #84909f;
		border-color: #e1e6eb;
		background: #f7f8fa;
	}
	.group-tag.is-unassigned i {
		color: #a7b0ba;
	}
	.muted-count {
		color: #a6afbb;
	}
	.danger-button {
		color: #d96868;
	}
	.dialog-tip {
		margin: 0 0 20px;
		padding: 11px 13px;
		color: #567188;
		border-radius: 8px;
		background: #f2f7fb;
		font-size: 13px;
	}
	.dialog-tip i {
		color: #4781a4;
		margin-right: 6px;
	}
	.field-help {
		margin: 6px 0 0;
		color: #8a98a6;
		font-size: 12px;
		line-height: 1.5;
	}
</style>
